// extracted by css-extract-rspack-plugin
export default {"widgetHeightByRatio":"widget-height-by-ratio--SNOhQWG0I4wg25UW","widgetHeightByRatioContent":"widget-height-by-ratio__content--uRlmnlloDhkNNfdW"};